import React from 'react'

import FormManager from "../../../../../../core/gd-form/common/form-manager"
import MultiselectOptions from "../../../../../../core/gd-ui/side-filters/multiselect-options/multiselect-options"
import RadioGroup from '../../../../../../core/gd-form/form-element/radio-group/radio-group'
import {useForceUpdate} from "../../../../../../core/gd/utils/dom-and-react/react-utils"
import {EventType} from "../../../../../../core/gd/const/event"
import CustomView_rowComponent from "../forms/common-blocks/row-component"

type Props = {
    form            : FormManager
    formFieldName   : string

    disabled?       : boolean
}

// const debug = "EventTypesBlock"
const debug = false

export default function EventTypesBlock(props: Props) {

    debug && console.log(debug, 'render', props)

    const forceUpdate = useForceUpdate()

    const eventTypes = props.form.getValue(props.formFieldName);

    const _updateEventTypes = (values: any, filterTypes: any) => {
        debug && console.log(debug, '_updateEventTypes', values, filterTypes)

        const eventTypes = _.chain(props.form.getValue(props.formFieldName))
            .filter(type=>!filterTypes.includes(type))
            .concat(values)
            .compact()
            .value()

        debug && console.log(debug, '_updateEventTypes eventTypes', eventTypes)

        // restrict last event type remove, just update to revert last selection
        if (eventTypes.length === 0) {
            forceUpdate()
            return
        }

        props.form.onFormComponentValueChange(props.formFieldName, eventTypes)
    }

    const onCompanyEventsChange     = (values: any) => {_updateEventTypes(values, gd.const.event.companyTypes)}
    const onProjectEventsChange     = (values: any) => {_updateEventTypes(values, gd.const.event.projectTypes)}
    const onPersonalEventsChange    = (values: any) => {_updateEventTypes(values, gd.const.event.personalTypes)}
    const onTaskEventsChange        = (value: any) => {_updateEventTypes([value], gd.const.event.taskTypes)}
    const onMeetingEventsChange     = (values: any) => {_updateEventTypes(values, gd.const.event.meetingTypes)}

    const companyEventsValues   = _.filter(eventTypes, eventType=>gd.const.event.companyTypes.includes(eventType))
    const projectEventsValues   = _.filter(eventTypes, eventType=>gd.const.event.projectTypes.includes(eventType))
    const personalEventsValues  = _.filter(eventTypes, eventType=>gd.const.event.personalTypes.includes(eventType))
    const taskEventsValue       = _.filter(eventTypes, eventType=>gd.const.event.taskTypes.includes(eventType))[0]
    const meetingEventsValues   = _.filter(eventTypes, eventType=>gd.const.event.meetingTypes.includes(eventType))

    const organizationEventsOptions = [
        {value: EventType.COMPANY_EVENT,      label: 'Company events'},
        {value: EventType.COMPANY_HOLIDAY,    label: 'Holidays'},
    ]

    const projectEventsOptions = [
        {value: EventType.PROJECT_DEADLINE,    label: 'Deadline'},
        {value: EventType.PROJECT_MILESTONE,   label: 'Milestones'},
        {value: EventType.PROJECT_EVENT,       label: 'Events'}
    ]

    const personalEventsOptions = [
        {value: EventType.PERSONAL_PAID_VACATION, label: 'Vacation'},
        {value: EventType.PERSONAL_TRAVEL,        label: 'Travel'},
        {value: EventType.PERSONAL_SICK_LEAVE,    label: 'Sick leave'},
    ]

    const taskEventsOptions = [
        {value: null,                       label: "Don't display"},
        {value: EventType.TASK_DEADLINE,    label: 'Deadlines'},
        {value: EventType.TASK_START_END,   label: 'Start/End'},
        {value: EventType.TASK_SCHEDULE,    label: 'Schedule'}
    ]

    const meetingsEventsOptions = [
        {value: EventType.MEETING, label: 'Meetings'},
    ]

    return (
        <>
            <CustomView_rowComponent label="Company">
                <MultiselectOptions type                = "form"
                                    title               = ""
                                    obligatoryItemsNum  = {0}
                                    filterTypes         = {companyEventsValues}
                                    typeFilterValues    = {organizationEventsOptions}
                                    isFoldable          = {false}
                                    onSelect            = {onCompanyEventsChange}/>
            </CustomView_rowComponent>

            <CustomView_rowComponent label="Project">
                <MultiselectOptions type                = "form"
                                    title               = ""
                                    obligatoryItemsNum  = {0}
                                    filterTypes         = {projectEventsValues}
                                    typeFilterValues    = {projectEventsOptions}
                                    isFoldable          = {false}
                                    onSelect            = {onProjectEventsChange}/>
            </CustomView_rowComponent>

            <CustomView_rowComponent label="Personal">
                <MultiselectOptions type                = "form"
                                    title               = ""
                                    obligatoryItemsNum  = {0}
                                    filterTypes         = {personalEventsValues}
                                    typeFilterValues    = {personalEventsOptions}
                                    isFoldable          = {false}
                                    onSelect            = {onPersonalEventsChange}/>
            </CustomView_rowComponent>

            <CustomView_rowComponent label="Tasks">
                <RadioGroup className   = "m-l-5"
                            value       = {taskEventsValue ? taskEventsValue : null}
                            items       = {taskEventsOptions}
                            onChange    = {onTaskEventsChange}/>
            </CustomView_rowComponent>

            <CustomView_rowComponent label="Meetings">
                <MultiselectOptions type                = "form"
                                    title               = ""
                                    obligatoryItemsNum  = {0}
                                    filterTypes         = {meetingEventsValues}
                                    typeFilterValues    = {meetingsEventsOptions}
                                    isFoldable          = {false}
                                    onSelect            = {onMeetingEventsChange}/>
            </CustomView_rowComponent>
        </>
    )
}